import { ResponseLevel, Step } from '../api/getTestsQuestions';

export function getSelectedStringValues(
  answers: number[],
  options: ResponseLevel[]
): string[] {
  return answers.map(answer => {
    // Находим вариант, соответствующий текущему числовому ответу
    const matchingOption = options.find(option => option.s === answer);

    // Если найден соответствующий вариант, возвращаем его текстовое значение
    // Иначе возвращаем пустую строку или можно выбросить ошибку
    return matchingOption ? matchingOption.t : '';
  });
}

export const ResultItem = ({
  index,
  step,
  scoreList,
}: {
  index: number;
  step: Step;
  scoreList: number[];
}) => {
  const answers = getSelectedStringValues(scoreList, step.v);

  return (
    <li className="mb-3 ml-5">
      {step.g} <span className="font-bold">({answers[index]})</span>
    </li>
  );
};
